import React, { useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import junior from 'assets/images/junior.jpg'
import piacievski from 'assets/images/piacievski.jpg'
import petrassi from 'assets/images/petrassi.jpg'
import teixeira from 'assets/images/teixeira.jpg'
import Header from 'components/Header'
import Footer from 'components/Footer'

const AboutLawyer = () => {
  const { slug } = useParams()

  const data = [
    {
      name: 'Dr. José Macias Nogueira Junior',
      specialization: 'Direito Empresarial',
      email: 'jrmaciasjr@gmail.com',
      image: junior,
      oab: 'OAB/PR - 31.848',
      slug: 'jose-macias-nogueira-junior',
      bio: 'Graduado em Direito, o Dr. José Macias Nogueira Junior consolidou sua carreira com forte foco em Direito Empresarial. Sua atuação destaca-se pela visão corporativa e estratégica, auxiliando empresas a tomarem decisões seguras. É reconhecido por seu comprometimento com a ética e por estruturar soluções jurídicas preventivas e contenciosas que protegem e impulsionam os negócios de seus clientes.',
    },
    {
      name: 'Dr. Diego Pulzatto Piacievski',
      specialization: 'Direito Civil e Penal',
      email: 'escritoriopiacievski@gmail.com',
      image: piacievski,
      oab: 'OAB/PR - 76.292',
      slug: 'diego-pulzatto-piacievski',
      bio: 'O Dr. Diego Pulzatto Piacievski é bacharel em Direito com vasta e sólida experiência técnica nas esferas Civil e Penal. Com forte vivência nos tribunais, ele oferece uma defesa combativa, incisiva e altamente individualizada. Seu foco primordial é garantir a preservação irrestrita dos direitos de seus clientes, atuando com rigor analítico e transparência na resolução de conflitos complexos.',
    },
    {
      name: 'Dra. Renata Lima Petrassi',
      specialization: 'Recuperação de Crédito',
      email: 'renataft_advogada@hotmail.com',
      image: petrassi,
      oab: 'OAB/PR - 60.469',
      slug: 'renata-lima-petrassi',
      bio: 'Formada em Direito, a Dra. Renata Lima Petrassi concentra sua expertise na área de Recuperação de Crédito. Profissional ágil e com grande habilidade de negociação, atua tanto na via extrajudicial quanto na contenciosa para garantir a reabilitação financeira e a satisfação ágil dos créditos de seus clientes, sempre pautada pela máxima eficiência, clareza e transparência processual.',
    },
    {
      name: 'Dra. Renata Fontes Pereira Teixeira',
      specialization: 'Direito de Família e Civil',
      email: 'renata.fontes@maciasecruz.com.br',
      image: teixeira,
      oab: 'OAB/PR - 57.496',
      slug: 'renata-fontes-pereira-teixeira',
      bio: 'Especialista em Direito de Família e Civil, a Dra. Renata Fontes Pereira Teixeira une sua sólida formação acadêmica a um atendimento profundamente humanizado. Compreendendo a delicadeza e a complexidade das demandas familiares, atua com empatia e firmeza, priorizando a mediação inteligente de conflitos e a proteção patrimonial e afetiva de seus clientes com absoluta ética e sigilo.',
    },
  ]

  const lawyer = data.find((lawyer) => lawyer.slug === slug)

  useEffect(() => {
    if (lawyer) {
      document.title = `Macias & Cruz - ${lawyer.name}`
      window.scrollTo(0, 0)
    }
  }, [lawyer])

  if (!lawyer) {
    return (
      <main className='flex w-full min-h-screen flex-col items-center justify-center py-6'>
        <Header />
        <div className="flex-grow flex flex-col gap-4 items-center justify-center">
          <h2 className="text-2xl font-bold">Advogado não encontrado.</h2>
          <Link to="/" className="text-blue-600 hover:underline">← Voltar</Link>
        </div>
        <Footer />
      </main>
    )
  }

  return (
    <main className='flex w-full flex-col items-center justify-center py-6'>
      <Header />
      <div className='my-20 flex w-11/12 flex-col items-center justify-center gap-6 md:w-9/12 md:flex-row md:gap-12 md:items-start'>
        
        {/* Imagem */}
        <img 
          src={lawyer.image} 
          alt={lawyer.name} 
          className='w-full max-w-sm rounded-lg shadow-lg md:w-1/3 object-cover' 
        />
        
        {/* Informações */}
        <div className='flex w-full flex-col md:w-2/3'>
          
          {/* Nome no topo */}
          <div className="mb-6 border-b border-gray-200 pb-4">
            <h1 className='text-3xl font-bold text-gray-900 md:text-5xl'>{lawyer.name}</h1>
          </div>
          
          {/* Biografia */}
          <p className='text-gray-700 text-justify text-lg leading-relaxed md:text-xl mb-8'>
            {lawyer.bio}
          </p>
          
          {/* Dados Técnicos e Contato (Abaixo do parágrafo) */}
          <div className='flex flex-col gap-2 border-t border-gray-200 pt-4 mt-auto'>
            <h3 className="text-xl font-semibold mb-2">Informações</h3>
            
            <p className='text-gray-600 text-lg'>
              <span className="font-semibold">Registro:</span> {lawyer.oab}
            </p>
            
            <p className='text-gray-600 text-lg'>
              <span className="font-semibold">E-mail:</span>{' '}
              <a href={`mailto:${lawyer.email}`} className="text-blue-600 hover:underline transition-colors">
                {lawyer.email}
              </a>
            </p>
          </div>

        </div>
      </div>
      <Footer />
    </main>
  )
}

export default AboutLawyer